import {Injectable} from '@angular/core';
import {TaskCommentModel} from '../models/task.model';
import {CrmService} from './api/crm.service';

@Injectable({
    providedIn: 'root'
})
export class CommentsService {

    constructor(
        private crmService: CrmService,
    ) {
    }

    public getCommentsHandler(key: string | number, type: string): Promise<any> {
        return new Promise((resolve) => {
            switch (type) {
                case'task':
                    this.crmService.getTaskComments(key as string).subscribe(res => {
                        resolve(this.commentsHelper(res.comments));
                    });
                    break;

                case 'assignment':
                    this.crmService.getAssignmentTasks(key as number).subscribe(res => {
                        resolve(this.commentsHelper(res.comments));
                    });
                    break;
            }
        });
    }

    public createComment(type: string, key: string | number, message: string): Promise<any> {
        return new Promise((resolve, reject) => {
            switch (type) {
                case'task':
                    this.crmService.sendTaskComment(key as string, message).subscribe({
                        next: data => {
                            resolve(data);
                        }, error: err => {
                            reject(err);
                        },
                    });
                    break;

                case 'assignment':
                    this.crmService.sendAssignmentComment(key as number, message).subscribe({
                        next: data => {
                            resolve(data);
                        }, error: err => {
                            reject(err);
                        },
                    });
                    break;
            }
        });
    }

    public editComment(type: string, commentId: number, commentMessage: string): Promise<any> {
        return new Promise((resolve, reject) => {
            switch (type) {
                case'task':
                    this.crmService.editTaskComment(commentId, commentMessage).subscribe({
                        next: res => {
                            resolve(res);
                        },
                        error: error => {
                            reject(error);
                        },
                    });
                    break;

                case 'assignment':
                    this.crmService.editAssignmentComment(commentId, commentMessage).subscribe({
                        next: res => {
                            resolve(res);
                        },
                        error: error => {
                            reject(error);
                        },
                    });
                    break;
            }
        });
    }

    public deleteComment(type: string, commentId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            switch (type) {
                case'task':
                    this.crmService.deleteTaskComment(commentId).subscribe({
                        next: res => {
                            resolve(res);
                        },
                        error: error => {
                            reject(error);
                        },
                    });
                    break;

                case 'assignment':
                    this.crmService.deleteAssignmentComment(commentId).subscribe({
                        next: res => {
                            resolve(res);
                        },
                        error: error => {
                            reject(error);
                        },
                    });
                    break;
            }
        });
    }

    private commentsHelper(data: any): TaskCommentModel[] {
        const commentsData: TaskCommentModel[] = [];

        for (const comment of data) {
            if (commentsData.length && commentsData[commentsData.length - 1].member_guid === comment.member_guid) {
                commentsData[commentsData.length - 1].comments.push(comment);
            } else {
                comment.comments = [Object.assign({}, comment)];
                commentsData.push(comment);
            }
        }

        return commentsData;
    }
}
